import * as angular from 'angular';
import { ComponentDefinition } from '../../../models';

class ConfirmApplyAllModalController implements angular.IComponentController {
    isIgnore: boolean;
    isLoading: boolean;
    message: string;
    modalId: string;
    title: string;

    static $inject = [];

    $onInit() {
        this.message = this.isIgnore
            ? 'Do you want to ignore all modifications in all groups?'
            : 'Do you want to push all modifications from template to all groups?';
        this.title = this.isIgnore
            ? 'Ignore all modifications'
            : 'Push all modifications';
    }
}

export const wtConfirmApplyAllModal: ComponentDefinition = {
    componentId: 'wtConfirmApplyAllModal',
    controller: ConfirmApplyAllModalController,
    controllerAs: 'vm',
    template: require('./confirmApplyAllModal.component.html'),
    bindings: {
        modalId: '@',
        templateGuid: '<',
        apply: '&',
        isIgnore: '<?',
    }
};